export const createSettingsWorkspaceRoutes = (basePath: string) =>
  ({
    index: basePath,
    cancelWorkspace: `${basePath}/cancel-workspace`,
  }) as const;
